import React from 'react';
import BooksForm from '../Components/BooksForm';

const AddBook = () => {
  return (
    <div>
      <BooksForm />
    </div>
  );
};

export default AddBook;
